export enum OrderMetaFieldName {
  Brand = 'Brand',
  Factory = 'Factory',
  ReflectiveProduct = 'Reflective product',
  Segment = 'Segment',
  GarmentType = 'Garment type',
  GarmentQuantity = 'Garment quantity',
  Quantity = 'Quantity',
}
